<template>
    <div class="modal-card" style="width:750px">
        <header class="modal-card-head">
            <p class="modal-card-title">Send epostrapport nå</p>
        </header>
        
        <section class="modal-card-body">
            <div class="columns" v-if="showFullDateSelection">
                <div class="column">
                    <b-field label="Startdato for uttrekk">
                        <b-datepicker v-model="fromDate" inline></b-datepicker>
                    </b-field>
                </div>
                <div class="column">
                    <b-field label="Sluttdato for uttrekk">
                        <b-datepicker v-model="toDate" inline></b-datepicker>
                    </b-field>
                </div>
            </div>
            

            

            <b-field label="Rapport for" v-if="showYearSelection">
                <b-select placeholder="Velg år" v-model="selectedYear" required>
                    <option
                        v-for="option in years"
                        :value="option"
                        :key="option">
                        {{ option }}
                    </option>
                </b-select>
            </b-field>


        </section>

        <footer class="modal-card-foot">
            <button class="button" type="button" @click="$parent.close()">Avbryt</button>
            <button class="button is-primary" @click="commitChanges()">Ok</button>
        </footer>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
const today = new Date()

export default {
    props: ['emailItem', 'receiver'],
    data () {
        return {
            fromDate: new Date(today.getFullYear(), today.getMonth(), 1),
            toDate: new Date(today.getFullYear(), today.getMonth() + 1, 0),
            errorMsg: undefined,
            selectedYear: this.$moment().year(),
            showFullDateSelection: true,
            showYearSelection: false
        }
    },
    methods: {
        ...mapActions('emailreports', ['sendEmailReport']),
        async commitChanges () {
            try {
                const request = {
                    receivers: this.receiver,
                    baxNumbers: this.emailItem.baxNumbers.join(),
                    branchId: this.emailItem.branchId,
                    reportType: this.emailItem.reportType,
                    outputFormat: this.emailItem.exportFormat,
                    startDate: this.fromDate,
                    endDate: this.toDate
                }

                if (this.showYearSelection)
                    request.startDate = this.$moment(`${this.selectedYear}-12-15`).toDate()

                await this.sendEmailReport(request)

                this.$parent.close()
            } catch (error) {
                this.errorMsg = error.message
            }
        }
    },
    computed: {
        ...mapGetters('emailreports', ['years'])
    },
    mounted () {
        if (this.emailItem.reportType === 6) {
            this.showFullDateSelection = false
            this.showYearSelection = true
        }
    }
}
</script>
